import BlockPadding from '@/components/block-padding';
import Media from '@/components/media';
import { Button, Header2, Header3, P1 } from '@bumble/ui-kit';

import styles from './product-cards-box.module.scss';

export default function ProductCardsBox({ data }: { data: any }) {
  const { products, title, description } = data || {};

  return (
    <BlockPadding maxWidth="large">
      <div className={styles.copy}>
        <Header2>{title}</Header2>
        <P1>{description}</P1>
      </div>

      <div className={styles.product__cards}>
        {products?.map((product: any, index: number) => {
          const { link, targetBlank, text } = product?.cta || {};

          return (
            <article key={index} className={styles.card}>
              <div className={styles.card__content}>
                <div className={styles.card__image}>
                  <Media media={product?.image} fill={true} />
                </div>

                <div className={styles.card__copy}>
                  <Header3 type="h3">{product?.name}</Header3>

                  <Button text={text} href={link} isTargetBlank={targetBlank} size="small" />
                </div>
              </div>
            </article>
          );
        })}
      </div>
    </BlockPadding>
  );
}
